// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yMaghTtV {
  min-height: 100vh;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  padding: 1.5rem;
}
.ao91ymuX {
  text-align: center;
  max-width: 31.25rem;
}
.qglo10_l {
  font-size: 2rem;
  font-weight: bold;
  color: #f5222d;
  margin-bottom: 1rem;
}
.mAmIKvSB {
  font-size: 1rem;
  color: #666666;
  margin-bottom: 1.5rem;
}
.Y1Ttci39 {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  gap: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/ErrorBoundary/ErrorBoundary.module.less","webpack://./src/styles/mixins.less"],"names":[],"mappings":"AAGA;EACE,iBAAA;ECyBA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EDzBA,eAAA;AAAF;AAGA;EACE,kBAAA;EACA,mBAAA;AADF;AAIA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAFF;AAKA;EACE,eAAA;EACA,cAAA;EACA,qBAAA;AAHF;AAMA;EACE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,SAAA;AAJF","sourcesContent":["@import '@/styles/variables.less';\n@import '@/styles/mixins.less';\n\n.errorBoundary {\n  min-height: 100vh;\n  .flex-center();\n  padding: @spacing-lg;\n}\n\n.content {\n  text-align: center;\n  max-width: 31.25rem; // 500px\n}\n\n.title {\n  font-size: @font-size-xxxl;\n  font-weight: bold;\n  color: @error-color;\n  margin-bottom: @spacing-md;\n}\n\n.message {\n  font-size: @font-size-md;\n  color: @text-color-secondary;\n  margin-bottom: @spacing-lg;\n}\n\n.actions {\n  display: flex;\n  justify-content: center;\n  gap: @spacing-md;\n}\n\n","@import './variables.less';\n\n// 响应式 Mixins\n.mobile(@rules) {\n  @media (max-width: 767px) {\n    @rules();\n  }\n}\n\n.tablet(@rules) {\n  @media (min-width: 768px) and (max-width: 1023px) {\n    @rules();\n  }\n}\n\n.desktop(@rules) {\n  @media (min-width: 1024px) {\n    @rules();\n  }\n}\n\n.tablet-up(@rules) {\n  @media (min-width: 768px) {\n    @rules();\n  }\n}\n\n// Flexbox Mixins\n.flex-center() {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.flex-between() {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.flex-start() {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n// 文本省略\n.text-ellipsis() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-ellipsis-multi(@lines: 2) {\n  display: -webkit-box;\n  -webkit-line-clamp: @lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n// 清除浮动\n.clearfix() {\n  &::after {\n    content: '';\n    display: table;\n    clear: both;\n  }\n}\n\n// 按钮重置\n.button-reset() {\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  outline: none;\n  font-family: inherit;\n}\n\n// 触摸友好\n.touch-friendly() {\n  min-height: 2.75rem; // 44px\n  min-width: 2.75rem; // 44px\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorBoundary": `yMaghTtV`,
	"content": `ao91ymuX`,
	"title": `qglo10_l`,
	"message": `mAmIKvSB`,
	"actions": `Y1Ttci39`
};
export default ___CSS_LOADER_EXPORT___;
